/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepsJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepsJob';
export const ixcSweepsClearingV1SweepsJobStateEntity = new schema.Entity<IxcSweepsClearingV1SweepsJobState>(IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'sweepsJobId' });

